import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss']
})
export class IconComponent implements OnInit {

  socialItem = [
    'twitter',
    'facebook',
    'instagram',
    'linkedin',
    'youtube-play',
    'pinterest',
    'skype',
    'wordpress',
    'google',
    'dropbox',
    'google-plus',
    'whatsapp'
  ];

  otherItem =  [
    'address-book',
    'book',
    'camera',
    'calendar',
    'circle',
    'check-square',
    'circle-o',
    'copyright',
    'comments',
    'envelope',
    'credit-card',
    'download',
    'heart',
    'mobile',
    'phone',
    'tablet',
    'television',
    'question',
    'remove',
    'sign-in',
    'search',
    'star',
    'tags',
    'user',
    'trash',
  ];

  constructor() { }

  ngOnInit() {
  }

}
